/*
 * Free gift threshold message for the Recharge storefront-experiences cart drawer.
 *
 * Display only. The EG Auto Add to Cart app adds and removes the gift; this file
 * never changes the cart. Config comes from snippets/cart-gwp-threshold.liquid.
 *
 * Cart state: Recharge publishes "cart:update" with the full cart on every drawer
 * refresh (open, add, change, remove). The MutationObserver only re-mounts the
 * message when the drawer re-renders; it never reads cart state.
 */
(function () {
  var configEl = document.getElementById('CartGwpThresholdConfig');
  if (!configEl) return;
  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }

  var HOST_ID = 'recharge-storefront-experiences__cart-drawer';
  var NODE_CLASS = 'cart-gwp-threshold';
  // Line item properties that mark a gift line. EG Auto Add uses "_Gifted".
  var GIFT_PROPERTIES = ['_Gifted', '_gift'];

  var lastCart = null;
  var subscribed = false;
  var fetching = false;
  var shadowObserved = false;

  var STYLE =
    '.' + NODE_CLASS + '{' +
    'padding:8px var(--storefront-drawer-padding-right,24px) 8px var(--storefront-drawer-padding-left,24px);' +
    'background:var(--storefront-drawer-secondary,#e3ebf0);' +
    'color:var(--storefront-drawer-foreground,#000);' +
    'font-size:14px;line-height:20px;text-align:center;}' +
    '.' + NODE_CLASS + ' p{margin:0;}' +
    '.' + NODE_CLASS + '__price{font-weight:600;}';

  function formatMoney(cents) {
    var format = config.moneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withDelimiters = function (whole, delimiter) {
      return whole.replace(/\B(?=(\d{3})+(?!\d))/g, delimiter);
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, key) {
      switch (key) {
        case 'amount_no_decimals':
          return withDelimiters(String(Math.round(cents / 100)), ',');
        case 'amount_with_comma_separator':
          return withDelimiters(parts[0], '.') + ',' + parts[1];
        case 'amount_no_decimals_with_comma_separator':
          return withDelimiters(String(Math.round(cents / 100)), '.');
        default:
          return withDelimiters(parts[0], ',') + '.' + parts[1];
      }
    });
  }

  function isGiftLine(item) {
    var props = item.properties || {};
    return GIFT_PROPERTIES.some(function (key) {
      return props[key] !== undefined && props[key] !== null && props[key] !== '';
    });
  }

  // EG Auto Add counts the cart before discount codes, so this does too:
  // the full price of every line that is not a gift line.
  function eligibleSpend(cart) {
    return cart.items.reduce(function (sum, item) {
      return isGiftLine(item) ? sum : sum + item.original_line_price;
    }, 0);
  }

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text || '';
    return div.innerHTML;
  }

  function messageHtml(cart) {
    var remaining = config.threshold - (cart ? eligibleSpend(cart) : 0);
    if (remaining > 0) {
      return escapeHtml(config.incomplete).replace(
        '[price]',
        '<span class="' + NODE_CLASS + '__price">' + escapeHtml(formatMoney(remaining)) + '</span>'
      );
    }
    return escapeHtml(config.complete);
  }

  function drawerHeader() {
    var host = document.getElementById(HOST_ID);
    if (!host || !host.shadowRoot) return null;
    return host.shadowRoot.querySelector('#cart-drawer > header');
  }

  function render() {
    var header = drawerHeader();
    if (!header) return;
    var node = header.querySelector(':scope > .' + NODE_CLASS);
    if (!node) {
      node = document.createElement('div');
      node.className = NODE_CLASS;
      node.setAttribute('role', 'status');
      node.setAttribute('aria-live', 'polite');
      node.innerHTML = '<style>' + STYLE + '</style><p></p>';
    }
    // Keep the message last in the header, under the cart title and any shipping bar.
    if (header.lastElementChild !== node) header.appendChild(node);
    var html = messageHtml(lastCart);
    var p = node.querySelector('p');
    if (p.innerHTML !== html) p.innerHTML = html;
    if (!lastCart) loadCart();
  }

  function loadCart() {
    if (fetching) return;
    fetching = true;
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        if (!lastCart) lastCart = cart;
        render();
      })
      .catch(function () {})
      .finally(function () {
        fetching = false;
      });
  }

  function subscribe() {
    if (subscribed || !window.RechargePubSub || typeof window.RechargePubSub.subscribe !== 'function') return;
    subscribed = true;
    window.RechargePubSub.subscribe('cart:update', function (payload) {
      if (payload && payload.cart) {
        lastCart = payload.cart;
        render();
      }
    });
  }

  function observeShadow(host) {
    if (shadowObserved) return;
    shadowObserved = true;
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        subscribe();
        render();
      });
    }).observe(host.shadowRoot, { childList: true, subtree: true });
    subscribe();
    render();
  }

  function findHost() {
    var host = document.getElementById(HOST_ID);
    if (host && host.shadowRoot) {
      observeShadow(host);
      return true;
    }
    return false;
  }

  subscribe();
  window.addEventListener('load', findHost);
  if (!findHost()) {
    var hostObserver = new MutationObserver(function () {
      if (findHost()) hostObserver.disconnect();
    });
    hostObserver.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
